import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import FormikInlineTextField from '@/components/shared/blocks/FormikInlineTextField';
import { EventNames, TEXTS } from '@/constants';
import { AmplitudeLogger } from '@/utilities/analyticsHelper';
import useDirectEnrollmentData from '@/components/hooks/useDirectEnrollmentData';

const {
  LABELS: { FIRST_NAME, LAST_NAME },
  ONE_CLICK_ENROLLMENT: {
    VERIFY_INFO_HEADING_SUFFIX,
    VERIFY_INFO_SUBHEADING,
    VERIFY_INFO_STEP_NAME,
  },
} = TEXTS;

interface VerifyInfoProps {
  logger: AmplitudeLogger;
}

const VerifyInfo: React.FC<VerifyInfoProps> = ({ logger }: VerifyInfoProps) => {
  const firstName = 'firstName';
  const lastName = 'lastName';
  const { fetch } = useDirectEnrollmentData();
  const { groupDisplayName } = fetch();

  useEffect(() => {
    logger({
      name: EventNames.SCREEN_VIEWED,
      data: {
        step_name: VERIFY_INFO_STEP_NAME,
      },
    });
  }, []);

  return (
    <>
      <Typography variant="h1">
        {groupDisplayName} {VERIFY_INFO_HEADING_SUFFIX}
      </Typography>
      <Typography variant="subtitle1">{VERIFY_INFO_SUBHEADING}</Typography>
      <FormikInlineTextField name={firstName} id={firstName} label={FIRST_NAME} autoFocus />
      <FormikInlineTextField name={lastName} id={lastName} label={LAST_NAME} />
    </>
  );
};

export default VerifyInfo;
